<h1 class="heading-primary">Search Claims</h1>
<dxo-card bodyHeader="Search is currently being redesigned">
  <div id="body-content">{{ cardBody }}</div>
  <dxo-button
    icon="open_in_new"
    iconColor="white"
    [primary]="true"
    [text]="detailsButtonLabel"
    [href]="detailsURL"
    [newWindow]="true"
  />
</dxo-card>
